import Layout from '@/views/layout'

export default [
  {
    path: '/vipMarket',
    name: 'vipMarket',
    redirect: '/vipMarket/vipDashboard',
    component: Layout,
    meta: {
      title: '用户营销',
      icon: 'vipMarket.png',
      index: 3
    },
    children: [
      {
        path: 'vipDraw',
        name: 'vipDraw',
        meta: {
          title: '精准发券',
          id: '1628236627',
          trackName: '会员管理-会员画像'
        },
        component: () => import('@/views/vipMarket/vipDraw2')
      },
      {
        path: 'userMarketData',
        name: 'userMarketData',
        meta: {
          title: '发券效果',
          id: '1638794971',
          trackName: '用户营销-营销数据	'
        },
        component: () => import('@/views/vipMarket/userMarketData')
      },
      {
        path: 'taskList',
        name: 'taskList',
        meta: {
          title: '发券记录'
        },
        component: () => import('@/views/vipMarket/taskList')
      },
      {
        path: 'vipDashboard',
        name: 'vipDashboard',
        meta: {
          title: '用户数据'
        },
        component: () => import('@/views/vipMarket/vipDashboard')
      },
      {
        path: 'sendCoupon',
        name: 'sendCoupon',
        hidden: true,
        meta: {
          title: '会员发券'
        },
        component: () => import('@/views/vipMarket/sendCoupon/index')
      }
    ]
  }
]